<!--
  @deprecated Please use `TmCustomTooltip` or v-tooltip directive instead.
-->
<template>
  <div>
    <div
      @mouseenter="mouseenterOnActivatorHandler"
      @mouseleave="mouseleaveOnActivatorHandler"
    >
      <slot name="activator" />
    </div>
    <tm-tooltip
      :white="white"
      :position="position"
      :model-value="isOpen"
      :hide-delay="hideDelay"
      :max-width="maxWidth"
      :is-allow-pointer-events="true"
      :is-default-padding="isDefaultPadding"
      :content-class="contentClass"
      @update:model-value="updateModelValueHandler"
      @show="showTooltipHandler"
      @before-show="beforeShowHandler"
      @before-hide="beforeHideHandler"
    >
      <div ref="tooltipContentElement">
        <slot name="tooltip-content" />
      </div>
    </tm-tooltip>
  </div>
</template>

<script setup lang="ts">
/**
 * @deprecated Please use `TmCustomTooltip` or v-tooltip directive instead.
 */
import { onUnmounted, ref, watch } from '@/composition/vue/compositionApi'
import TmTooltip from '@/components/shared/tooltip/TmTooltip.vue'
import type { ControlPosition } from '@/composition/tooltip/renderTooltip'
import type { VueLikeClassAttr } from '@/components/types'
import type { StylesheetSizeProp } from '@/types'

const props = withDefaults(
  defineProps<{
    hideDelay?: number
    position?: ControlPosition
    white?: boolean
    maxWidth?: StylesheetSizeProp
    isDefaultPadding?: boolean
    contentClass?: VueLikeClassAttr
  }>(),
  {
    white: false,
    isDefaultPadding: true,
  },
)

const emit = defineEmits<{
  'before-show': []
  'before-hide': []
  'update:model-value': [boolean]
}>()

const tooltipContentElement = ref<HTMLDivElement | null>(null)
const isOpen = ref(false)
const isCursorOnActivator = ref(false)
const isCursorOnContent = ref(false)

const updateModelValueHandler = async (e) => {
  if (e) {
    isCursorOnContent.value = false
  } else if (isCursorOnContent.value) {
    return
  }
  isOpen.value = e
}

const mouseenterOnTooltipContentHandler = () => {
  isCursorOnContent.value = true
}

let timeoutId: number | null = null

const mouseleaveOnTooltipContentHandler = () => {
  isCursorOnContent.value = true
  timeoutId = window.setTimeout(() => {
    if (isCursorOnActivator.value) {
      return
    }
    isOpen.value = false
  }, props.hideDelay)
}

const mouseenterOnActivatorHandler = () => {
  isCursorOnActivator.value = true
}

const mouseleaveOnActivatorHandler = () => {
  isCursorOnActivator.value = false
}

const close = () => {
  isCursorOnContent.value = false
  isCursorOnActivator.value = false
  isOpen.value = false
}

defineExpose({ close })

let tooltipElement: HTMLDivElement | null = null

const showTooltipHandler = (el: HTMLDivElement) => {
  tooltipElement = null
  el.addEventListener('mouseenter', mouseenterOnTooltipContentHandler)
  el.addEventListener('mouseleave', mouseleaveOnTooltipContentHandler)
}

const removeTooltipContentListeners = () => {
  if (!tooltipElement) {
    return
  }
  tooltipElement.addEventListener('mouseenter', mouseenterOnTooltipContentHandler)
  tooltipElement.addEventListener('mouseleave', mouseleaveOnTooltipContentHandler)
}

const beforeShowHandler = () => {
  emit('before-show')
}

const beforeHideHandler = () => {
  emit('before-hide')
  removeTooltipContentListeners()
}

onUnmounted(() => {
  removeTooltipContentListeners()
  if (timeoutId !== null) {
    clearTimeout(timeoutId)
  }
})

watch(
  isOpen,
  (e) => {
    emit('update:model-value', e)
  },
  {
    immediate: true,
  },
)
</script>
